export default __webpack_public_path__ + "static/media/PuntosDeMuestreoSantiago.e0eb6939.kml";